import { apiPost, API_BASE } from "./client";
import { getToken } from "@/lib/auth";

export interface FamilyFile {
  id: string;
  fileName: string;
  fileExtension: string;
}

export interface UploadedFile {
  fileId: string;
  fileName: string;
  fileSize: number;
}

export interface CreateFamilyPayload {
  pinfl: string;
  /** YYYY-MM-DD (HTML date input bilan mos) */
  birthDate: string;
  regionId: number;
  districtId: number;
  mfyId: number;
  patientName: string;
  patientSurname: string;
  phoneNumber: string;
  amount: number;
  mySelf: boolean;
  sickCategoryId: number;
  sickCotegoryComment: string | null;
  comment: string | null;
  typeHelpId: number;
  applicationSubmitterTypeId: number;
  files: FamilyFile[];
}

export function createFamily(payload: CreateFamilyPayload): Promise<unknown> {
  return apiPost<unknown>("/MiniApp/CreateApplication", payload);
}

export async function uploadFile(file: File): Promise<UploadedFile> {
  const formData = new FormData();
  formData.append("file", file);
  const headers: Record<string, string> = {};
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API_BASE}/Family/UploadFile`, {
    method: "POST",
    headers,
    body: formData,
  });
  if (!res.ok) throw new Error(`UploadFile: ${res.status}`);
  return res.json() as Promise<UploadedFile>;
}
